import * as React from 'react';
import {
  ComposedChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from 'recharts';
import NumberFormat from 'react-number-format';

import { formatAsDollars } from '../../../../lib/helpers';

const lightOrange = '#FFB74D';
const darkOrange = '#FFA726';
const lightBlue = '#4FC3F7';
const darkBlue = '#42a5f5';
const darkPurple = '#463264';
const lightPurple = '#c8bddb';

export interface Props {
  barSize?: number;
  data: any[];
  height?: string | number;
  margin?: number;
  width?: string | number;
}

const PriceAndRentChart = (props: Props) => (
  <ResponsiveContainer
    width={props.width || '100%'}
    height={props.height || 350}
  >
    <ComposedChart
      data={props.data}
      margin={{
        top: props.margin || 20,
        right: props.margin || 20,
        bottom: props.margin || 20,
        left: props.margin || 20,
      }}
    >
      <XAxis dataKey="month" />
      <YAxis
        yAxisId="left"
        orientation="left"
        stroke={darkPurple}
        tickFormatter={formatAsDollars}
      />
      <YAxis
        yAxisId="right"
        orientation="right"
        stroke={darkOrange}
        tickFormatter={formatAsDollars}
      />
      <Tooltip
        formatter={(val: any) => (
          <NumberFormat
            value={val}
            displayType="text"
            thousandSeparator
            prefix="$"
            decimalScale={0}
          />
        )}
      />
      <Legend />
      <Bar
        yAxisId="left"
        dataKey="medianPrice"
        name="Median Purchase Price"
        barSize={props.barSize || 20}
        fill={darkPurple}
      />
      <Line
        yAxisId="left"
        type="monotone"
        dataKey="priceTrend"
        name="Price Trend"
        stroke={lightPurple}
        strokeDasharray="5 5"
        connectNulls
        dot={false}
        activeDot={false}
        legendType="none"
      />
      <Line
        yAxisId="right"
        type="monotone"
        dataKey="medianRent"
        name="Median Rent"
        stroke={darkOrange}
        connectNulls
      />
      <Line
        yAxisId="right"
        type="monotone"
        dataKey="rentTrend"
        name="Rent Trend"
        stroke={lightOrange}
        strokeDasharray="5 5"
        connectNulls
        dot={false}
        activeDot={false}
        legendType="none"
      />
    </ComposedChart>
  </ResponsiveContainer>
);

export default PriceAndRentChart;
